/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss';
import styles from './placeholder_styles';

/* ========== ~~~~~~~~~~ ARTICLE CARD ~~~~~~~~~~ ========== */
const Placeholder = injectSheet(styles)(props => {

  const { width, height, radius} = props
    return (
      <div style={{ width: `${width || '100%'}`, height: `${height || 10}px`, borderRadius: `${radius || 8}px`}} className={`placeholder ${props.classes.placeholder}`}></div>
    )
})


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Placeholder;
